import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=138e00e3"
import script from "./PlayerInfo.vue?vue&type=script&lang=js"
export * from "./PlayerInfo.vue?vue&type=script&lang=js"
import style0 from "./PlayerInfo.vue?vue&type=style&index=0&id=138e00e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports